import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

// Import Redux action(s)
import { getMeasurementsAction, getMeasurementsSuccess } from '../../redux/actions/measurements.actions'
import { setChartContainerOpen } from '../../redux/actions/map.actions'
// Import local components
import MeasurementsPlotContainer from './MeasurementsPlotContainer'
import CustomLineChart from '../Charts/CustomLineChart'

export default function MeasurementsPlot() {
  const dispatch = useDispatch()

  const isChartContainerOpen = useSelector(
    (state) => state.mapStates.isChartContainerOpen,
  )
  const point = useSelector((state) => state.pointsStates.point)

  const { getMeasurementsPending, measurements } = useSelector(
    (state) => state.measurementsStates,
  )
  const { getPointPending } = useSelector((state) => state.pointsStates)

  const feature =
    point && point?.features && point.features.length ? point.features[0] : null

  useEffect(() => {
    if (feature) {
      dispatch(getMeasurementsAction(feature.properties.id))
    } else {
      dispatch(dispatch(getMeasurementsSuccess([])))
    }
  }, [dispatch, point, feature])

  const onClosePlotContainer = () => dispatch(setChartContainerOpen(false))

  return (
    <MeasurementsPlotContainer
      isLoading={getMeasurementsPending || getPointPending}
      isOpen={isChartContainerOpen}
      point={feature}
      onClose={onClosePlotContainer}
    >
      <CustomLineChart chartData={measurements}></CustomLineChart>
    </MeasurementsPlotContainer>
  )
}
